import { render, staticRenderFns } from "./CreateRolePage.vue?vue&type=template&id=e8b7555e&scoped=true"
import script from "./CreateRolePage.vue?vue&type=script&lang=js"
export * from "./CreateRolePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b7555e",
  null
  
)

export default component.exports